<template>
  <div class="dashboard-panel p-new-review">
    <div>
      <div class="panel-header">
        <h2>New Review</h2>

        <div v-if="review">
          <p>By: {{ review && review.user.fullName }}</p>
          <p>Submitted on: {{ review.createdAt | date }}</p>
        </div>
      </div>

      <div v-if="review" class="panel-content">
        <StarRatingGrid
          :data="review"
          :size="20" />

        <h2>Testimonial</h2>
        <p>
          {{ review.reviewDescription.substring(0, 140) }}
          {{ review.reviewDescription.length >= 140 ? '...' : '' }}
        </p>
      </div>

      <div v-if="!review">
        <p>
          There are no reviews yet
        </p>
      </div>

      <div class="panel-footer">
        <router-link
          class="default-btn link"
          :to="{ name: 'OrganizationReviews', params: { organizationId } }">
          View Reviews
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PanelNewReview',
  props: {
    organizationId: String,
    review: Object,
  },
}
</script>

<style lang="scss" scoped>
.dashboard-panel > div {
  width: 375px;
  padding: 0 20px;
}

.panel-footer {
  margin: 0 -20px;
}
</style>
